import classNames from 'classnames';
import * as React from 'react';
import { RootStore, withInjectedRootStore } from 'providers';
import { AdvancedPlansProductModel } from 'models/AdvancedPlansProductModel';
import { Devider } from './Devider';
import { Note } from './Note';
import s from './ProductNotes.scss';

interface ProductNotesProps {
  rootStore: RootStore;
  product: AdvancedPlansProductModel;
}

const ProductNotesComp: React.FC<ProductNotesProps> = ({
  product,
  rootStore,
}) => {
  const { advancedPlansProducts } = rootStore.appStore.appContext;
  const productsInType = advancedPlansProducts.filter(
    (p) => p.type === product.getType(),
  );

  const hasDoubleNotes = productsInType.some((prod) => {
    const candidate = new AdvancedPlansProductModel(prod, rootStore.appStore);
    return candidate.shouldShowAdsNote() && candidate.isCurrentPlanSameCode;
  });

  const hasAnyNote =
    product.shouldShowAdsNote() || product.isCurrentPlanSameCode;

  const noteKeys = {
    wixAds: 'product.note_wix_ads',
    changePlan: 'change_plan.plan_been_updated_notice',
  };

  return (
    <div
      className={classNames(s.wixNotes, { [s.double]: hasDoubleNotes })}
      data-testid='product-notes'
    >
      {product.shouldShowAdsNote() && (
        <Note
          noteKey={noteKeys.wixAds}
          dataHook='wix-ads-note'
          doubleNotes={hasDoubleNotes}
        />
      )}
      {product.isCurrentPlanSameCode && (
        <Note
          noteKey={noteKeys.changePlan}
          dataHook='change-plan-note'
          doubleNotes={hasDoubleNotes}
        />
      )}
      {!hasAnyNote && <Devider />}
    </div>
  );
};

export const ProductNotes = withInjectedRootStore(ProductNotesComp);
